import { Component, computed, input } from '@angular/core';
import { VisualElementComponent } from '@features/canvas/visual-element/visual-element.component';
import { LpCharacter, LpEmotion } from '@typings/lp/generated';

@Component({
  selector: 'lp-character',
  imports: [VisualElementComponent],
  templateUrl: './lp-character.component.html',
  styleUrl: './lp-character.component.css',
})
export class LpCharacterComponent {
  character = input.required<LpCharacter>();
  emotion = input<LpEmotion | 'Talking'>('Neutral');
  characterSpriteURL = computed(() => this.getSpriteUrlForEmotion(this.emotion()) ?? this.character().normalSprite.url);

  private getSpriteUrlForEmotion(emotion: LpEmotion | 'Talking'): string | undefined {
    const c = this.character();

    switch (emotion) {
      case 'Confused':
        return c.confusedSprite?.url;
      case 'Explaining':
        return c.explainingSprite?.url;
      case 'Happy':
        return c.happySprite?.url;
      case 'Mad':
        return c.madSprite?.url;
      case 'Neutral':
        return c.normalSprite?.url;
      case 'Sad':
        return c.sadSprite?.url;
      case 'Smirk':
        return c.smirkSprite?.url;
      case 'Surprised':
        return c.surprisedSprite?.url;
      case 'Talking':
        return c.talkingSprite?.url;
      case 'Thinking':
        return c.thinkingSprite?.url;
      case 'ThumbsUp':
        return c.thumbsUpSprite?.url;
      case 'Wave':
        return c.waveSprite?.url;
    }
  }
}
